import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { SharedService } from "../services/shared.service";
import { CclMessageService } from "certain-common-library";

@Injectable()
export class CatalogUuidResolver implements Resolve<object> {
    constructor(private sharedService: SharedService, private messageService: CclMessageService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): object {
        this.sharedService.redirectTo = route.url[0].path;
        const catalogUUID = route.paramMap.get("catalogUuid");
        this.sharedService.catalogUUID = catalogUUID;
        this.messageService.sendMessage("initialize-app", catalogUUID);
        return { catalogUUID: catalogUUID };
    }
}
